import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "reportv2",

    component: withAsyncRouteLoading(
      () =>
        Promise.all([import("./ReportV2")]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
